/**
 * The AP spring's water at Medium (lifted from the dungeon-floors prototype's
 * marker water material in `dungeon-markers.js`): rings travel out from the
 * basin's centre over time, the centre a little brighter. The top cap's
 * texture coordinates are radial about (0.5, 0.5). Knobs are compile-time
 * constants from `presentation.markerDetail.spring.ripple`.
 */
type Ripple = { readonly rings: number; readonly speed: number; readonly sharpness: number; readonly base: number; readonly centre: number; readonly ring: number; readonly centreEdge: readonly [number, number] };

const f = (n: number): string => (Number.isInteger(n) ? `${n}.` : String(n));

export const waterVertexHeader = 'varying vec2 abWaterUv;';
export const waterVertex = 'abWaterUv=uv;';
export const waterFragmentHeader = 'uniform float abWaterTime;varying vec2 abWaterUv;';

/** After `color_fragment`. */
export const waterFragment = (r: Ripple): string =>
  `float abD=length(abWaterUv-vec2(.5));float abRipple=pow(max(0.,sin(abD*${f(r.rings)}-abWaterTime*${f(r.speed)})),${f(r.sharpness)});` +
  `diffuseColor.rgb*=${f(r.base)}+${f(r.centre)}*(1.-smoothstep(${f(r.centreEdge[0])},${f(r.centreEdge[1])},abD))+${f(r.ring)}*abRipple;`;
